import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import App from "./App";

const AnanthEswar = ReactDOM.createRoot(document.getElementById("AnanthEswar"));

AnanthEswar.render(<App />);
